var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-px-8 tw-py-4 tw-border-t tw-border-gray-350"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }